import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';
import { safeGet } from '../../../core/util/object';
import Actions, { ActionImplementations } from './components/Actions';
import Breadcrumb from './components/BreadCrumb/components/Breadcrumb';
import { getCDPCrumbs } from './components/BreadCrumb/util/breadcrumb';
import ClaimClinic from './components/ClaimClinic';
import ClinicName from './components/ClinicName';
import ClinicPhoto from './components/ClinicPhoto';
import QuickDetails from './components/QuickDetails';
import Rating from './components/Rating';
import ReportInaccurateInfo from './components/ReportInaccurateInfo';

const ClinicPhotoContainer = styled(Grid)`
  min-width: -webkit-min-content;
  min-width: -moz-min-content;
  padding-right: 24px;
`;

const HeaderTopSection = styled.div`
  margin-bottom: 6px;
`;

const StyledRating = styled(Rating)`
  margin-top: 4px;
`;

const HeaderBottomSection = styled.div`
  margin-top: 30px;

  display: flex;
  flex-wrap: wrap;
  @media (min-width: 960px) and (max-width: 1024px) {
    flex-direction: column;
  }
`;

const StyledActions = styled(Actions)`
  margin: 8px 0;
`;

const ClaimAndReportContainer = styled.div`
  margin-left: 8px;
  @media (min-width: 960px) and (max-width: 1024px) {
    margin-top: 12px;
  }

  display: flex;
  align-self: center;
  flex-direction: column;
`;

export default class DesktopCdpHeaderCard extends PureComponent {
  static propTypes = {
    location: PropTypes.object,
    handleOpenCarousel: PropTypes.func,
    showModal: PropTypes.func,
    viewport: PropTypes.object,
    sessionTrackingProperties: PropTypes.object,
  };

  render = () => {
    const {
      location,
      handleOpenCarousel,
      showModal,
      viewport,
      sessionTrackingProperties,
    } = this.props;

    return (
      <Grid container wrap="nowrap">
        <ClinicPhotoContainer item xs={3}>
          <ClinicPhoto
            location={location}
            handleOpenCarousel={() => handleOpenCarousel('clinicPhoto')}
            viewport={viewport}
          />
        </ClinicPhotoContainer>

        <Grid item xs={9}>
          <HeaderTopSection>
            <Breadcrumb
              sessionTrackingProperties={sessionTrackingProperties}
              crumbs={getCDPCrumbs(location)}
            />
            <ClinicName
              primaryName={location.displayNamePrimary}
              secondaryName={location.displayNameSecondary}
              alternateName={location.alternateName}
            />
            <StyledRating location={location} showModal={showModal} />
          </HeaderTopSection>
          <QuickDetails location={location} />

          <HeaderBottomSection>
            <StyledActions
              implementation={ActionImplementations.DESKTOP}
              location={location}
              showModal={showModal}
            />
            <ClaimAndReportContainer>
              <ClaimClinic
                location={location}
                userAgent={safeGet(sessionTrackingProperties)('userAgent')}
              />
              <ReportInaccurateInfo location={location} showModal={showModal} />
            </ClaimAndReportContainer>
          </HeaderBottomSection>
        </Grid>
      </Grid>
    );
  };
}
